<template>
  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-bs-toggle="modal"
    data-bs-target="#uploadFile">
    {{ $t('key_import') }}
  </soft-button>
  <div id="uploadFile" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog mt-lg-10">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="ModalLabel" class="modal-title">
            {{ $t('key_import') }}
          </h5>
          <i class="fas fa-upload ms-3"></i>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">         
          <p>{{ $t('key_text_import_file') }}</p>
          <input ref="inputFile" type="file" placeholder="Browse file..." class="mb-3 form-control" @change="handleFileUpload($event)" />
          <hk-select v-model="dataFile.data.tipo" :placeholder="$t('key_select_file_format')" :options="optionsFormat"></hk-select>         
        </div>      
        <div class="modal-footer">
          <button id="close" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal" @click="limpiarFile()" >
            {{ $t('key_close') }}
          </button>
          <button type="button" class="btn bg-gradient-success" :disabled="btnUpload" @click="upload()">
            {{ $t('key_import') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import HkSelect from "@/hotaka/components/HkSelect.vue";
import { createAxios } from "@/services/axiosHttp";
export default {
  name: "HkBtnUploadModal",
  components: { SoftButton, HkSelect},
  props: {
    optionsFormat: {
      type: Array,
      default: () => {
        return [];
      },
    },
    url:{
      type: String,
      default: '',
    }
  },
  emits: ['success','failure'],
  data() {
    return {
      dataFile:{
        data:{tipo:''},
        batch: null
      }
    }
  },
  computed: {
    btnUpload(){
      return this.dataFile.batch== null || this.dataFile.data.tipo=='';
    }
  },
  mounted() {
  },
  methods: {
    upload() {
      const axios = createAxios();
      let dataForm= new FormData();
      dataForm.append('data', JSON.stringify(this.dataFile.data));
      dataForm.append('batch', this.dataFile.batch);
      let config = {header : {'Content-Type' : 'multipart/form-data'}}
      const user= JSON.parse(localStorage.getItem("user"));
      axios.post( `customer/${user.extraData.customerId}`+this.url, dataForm, config)
      .then((res) => {
        if(res.status=='KO') {
          this.$emit('failure',res.error);
        }
        this.$emit('success', res);
      }).catch(
        (error) => {
          this.$emit('failure',error);
        }
        )
        this.closeModal();
    },
    handleFileUpload(event){
      this.dataFile.batch= event.target.files[0];
    },
    closeModal() {
    document.getElementById('close').click();
    },
    limpiarFile(){
      this.$refs.inputFile.value=null;
    }
  }
}
</script>